let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
const NavSeparator = styledWithTheme.div(_t || (_t = _`
  height: 28px;
  width: 1px;
  background: ${0};
  margin: 0 6px;
`), ({
  theme: trellisTheme
}) => trellisTheme.color['do-not-use-slinky']);
export default NavSeparator;